import { SystemPreferenceKeys } from '@webapp/platform/iam/entities/enums/SystemPreferenceKeys'

const systemPreferencesQueryKey = 'system-preferences'

export const systemPreferencesKeys = {
  all: [systemPreferencesQueryKey] as const,
  defaultDisclaimer: [
    systemPreferencesQueryKey,
    SystemPreferenceKeys.DEFAULT_DISCLAIMER,
  ] as const,
  externalPONumbering: [
    systemPreferencesQueryKey,
    SystemPreferenceKeys.AUTO_PO_CUSTOM_SEQUENCE,
  ] as const,
  listMFASystemPreference: [
    systemPreferencesQueryKey,
    SystemPreferenceKeys.MULTI_FACTOR_AUTHENTICATION,
  ] as const,
  poPdfHiddenCustomFields: [
    systemPreferencesQueryKey,
    SystemPreferenceKeys.PO_PDF_CUSTOM_FIELDS_HIDDEN,
  ] as const,
  vendorInviteBatchLimit: [
    systemPreferencesQueryKey,
    SystemPreferenceKeys.VENDOR_INVITE_BATCH_LIMIT,
  ] as const,
}
